// @ts-nocheck
import * as React from "react";

const Import: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m12 15.577-3.539-3.538.708-.72L11.5 13.65V5h1v8.65l2.33-2.33.709.719L12 15.577ZM6.615 19c-.46 0-.844-.154-1.152-.462A1.565 1.565 0 0 1 5 17.384v-2.423h1v2.423c0 .154.064.296.192.424s.27.192.423.192h10.77a.588.588 0 0 0 .423-.192.588.588 0 0 0 .192-.424v-2.423h1v2.423c0 .46-.154.845-.462 1.154a1.565 1.565 0 0 1-1.154.462H6.616Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Import);
